<div class="link-wrapper">
  <FooterLink {href} {colorClassNames} {external} {additionalClassNames} {additionalIds}>
    {title}
  </FooterLink>
  <LinkIcon {icon} />
</div>

<style lang="less">
  .link-wrapper {
    display: flex;
  }
</style>

<script>
  import FooterLink from './FooterLink.html';
  import LinkIcon from './LinkIcon.html';

  export let href;
  export let title;
  export let additionalClassNames = [];
  export let external = false;
  export let colorClassNames;
  export let additionalIds = [];
  export let icon;
</script>
